import { FC } from 'react'
import {
  DatePicker as AntdDatePicker,
  type DatePickerProps as AntdDatePickerProps,
} from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import cn from 'classnames'
import classes from './index.module.css'

type DatePickerControlSize = 'middle' | 'small' | 'compact'

type DatePickerProps = AntdDatePickerProps & {
  controlSize?: DatePickerControlSize
}

type DateRangePickerProps = RangePickerProps & {
  controlSize?: DatePickerControlSize
}

const getPickerSizeClassName = (controlSize?: DatePickerControlSize) =>
  cn(classes.dataPicker, {
    [classes.dataPickerSmall]: controlSize === 'small',
    [classes.dataPickerCompact]: controlSize === 'compact',
  })

const DatePicker: FC<DatePickerProps> = ({ className, controlSize, ...props }) => {
  return (
    <AntdDatePicker
      {...props}
      className={cn(className, getPickerSizeClassName(controlSize))}
    />
  )
}

export const DateRangePicker: FC<DateRangePickerProps> = ({
  className,
  controlSize,
  ...props
}) => (
  <AntdDatePicker.RangePicker
    {...props}
    className={cn(className, getPickerSizeClassName(controlSize))}
  />
)

export default DatePicker
